import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

interface LatestUpdatesProps {
  comicIds: string[];
}

export default function LatestUpdates({ comicIds }: LatestUpdatesProps) {
  const latestComics = comicIds.map((id) => comics.find((c) => c.id === id)).filter(Boolean);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-2">
            <i className="ri-timer-flash-line text-accent-500 text-xl"></i>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">最新更新</h2>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {latestComics.map((comic) => (
            comic && (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="flex items-center gap-3 p-3 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer group"
              >
                <div className="w-16 h-20 flex-shrink-0 rounded-md overflow-hidden">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 最新第${comic.chapters[0]?.number}话`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-heading text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {comic.title}
                  </h4>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                    {comic.chapters[0]?.title || '暂无更新'}
                  </p>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className="text-xs text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {comic.status}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">
                      {comic.updatedAt}
                    </span>
                  </div>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
}